import { render, staticRenderFns } from "./indexStudent.vue?vue&type=template&id=d9d074ec"
import script from "./indexStudent.vue?vue&type=script&lang=js"
export * from "./indexStudent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports